import React from 'react';
import renderHTML from 'react-render-html';
import Accordion from '../accordion';

const LegalInfoView = (props) => {
  const { authorableContent } = props;
  const { businessCaseDisclaimer } = authorableContent;
  const { text, title } = businessCaseDisclaimer;
  return (
    <Accordion
      title={title}
      accordionWrapperClass="legal-info border-top-bottom col-sm-8"
      onLoadcollapse
      onClickOnFullAccordionWidth
    >
      {renderHTML(text)}
    </Accordion>
  );
};

export default LegalInfoView;
